import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import ItemScoreOverview from "./ItemScoreTabs/ItemScoreOverview";
import ItemScoreInsightView from "./ItemScoreTabs/ItemScoreInsightsView";

const ItemScoreViewsCard = (props) => {
    const selectedCategory = props.selectedCategory;
    const selectedProduct = props.selectedProduct;
    const [ overviewTab, setOverviewTab ] = useState(true);
    const [ insightsViewTab, setInsightsViewTab ] = useState(false);

    const handleViewInsights = (selectedItem) => {
        setOverviewTab(false);
        setInsightsViewTab(true);
        props.setShowProductSelect(true);
        props.setShowCategorySelect(false);
        props.setSelectedProduct({label: selectedItem.description.toLowerCase(), value: selectedItem.product_id});
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    const handleViewOverview = () => {
        setOverviewTab(true);
        setInsightsViewTab(false);
        props.setShowProductSelect(false);
        props.setShowCategorySelect(true);
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    useEffect(() => {
        handleViewOverview();
    // eslint-disable-next-line
    }, [props.refresh])

    return (
        <Row className="px-0 mb-2">
            <Col className="px-3 h-100">
                <Row style={{height: '85%'}}>
                    { overviewTab &&
                        <ItemScoreOverview selectedCategory={selectedCategory} handleViewInsights={handleViewInsights} overviewData={props.overviewData}/>
                    }
                    { insightsViewTab &&
                        <ItemScoreInsightView selectedCategory={selectedCategory} selectedProduct={selectedProduct} handleClickOverview={handleViewOverview}/>
                    }
                </Row>
            </Col>
        </Row>
    )
}

export default ItemScoreViewsCard;